var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 64,
    viewBox: "0 0 62 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.642,
    y1: 0.015,
    x2: 0.301,
    y2: 0.805,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4002f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#cf003c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0804b5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Expertise_and_Experience",
    "data-name": "Expertise and Experience",
    transform: "translate(-215.854 -2128.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9704",
    "data-name": "Path 9704",
    d: "M794.78,735.359c8.272,8.111,10.911,17.959,8.331,28.879-3.394,14.361-12.366,23.806-26.946,27.138C756.657,795.833,740.4,779.957,742.2,761c1.4-14.762,9.115-25.286,22.948-30.641C775.732,726.261,785.832,727.761,794.78,735.359Z",
    transform: "translate(-526.207 1400.468)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9767",
    "data-name": "Path 9767",
    d: "M18.157.785l4.119,8.276a1.414,1.414,0,0,0,1.062.777l9.218,1.332a1.42,1.42,0,0,1,.938.545,1.367,1.367,0,0,1-.15,1.833l-6.676,6.469a1.351,1.351,0,0,0-.4,1.237l1.609,9.116a1.4,1.4,0,0,1-1.158,1.585,1.532,1.532,0,0,1-.917-.143l-8.221-4.3a1.385,1.385,0,0,0-1.319,0L7.99,31.844a1.442,1.442,0,0,1-1.914-.587,1.409,1.409,0,0,1-.145-.888l1.609-9.116a1.4,1.4,0,0,0-.4-1.237L.412,13.548a1.4,1.4,0,0,1,0-1.982,1.618,1.618,0,0,1,.8-.4l9.218-1.332A1.446,1.446,0,0,0,11.5,9.061L15.615.785a1.393,1.393,0,0,1,.814-.712A1.418,1.418,0,0,1,17.514.15,1.453,1.453,0,0,1,18.157.785Z",
    transform: "translate(229.354 2143.101)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.7aa7d7984516faf81d4abba11e36d6fd.svg";
export { ForwardRef as ReactComponent };